import { getParticipantById } from '../base/participants/functions';
/**
 * Selector for the participant currently displaying on the minimized video.
 *
 * @param {Object} state - The redux state.
 * @returns {Object}
 */
export function getMinimizedVideoParticipant(state) {
    const { participantId } = state['features/minimized-video'];
    return getParticipantById(state, participantId ?? '');
}
